module.exports = __webpack_public_path__ + "static/media/Phone Categorie.3bed97c5.png";